import { useEffect, useState } from 'react';
import { DataGrid } from "@mui/x-data-grid";
import { CheckBox } from '@mui/icons-material';
import '../../../../../scss/pages/Attendance/Component/Attendance/AttendanceRequest/attendanceRequest.scss';
import { useDispatch } from "react-redux";
import { GET_ATTENDANCE_REQUEST_DATA, POST_ATTENDANCE_APPROVE_DATA, POST_ATTENDANCE_REJECT_DATA } from "../../../../../sagas/type";
import { getLocalStoreString } from '../../../../../utils/Helper';
import { useSelector } from 'react-redux';
import SmsIcon from '@mui/icons-material/Sms';
import { Button, FormControl, Modal, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useSnackbar } from 'notistack';
import requestEmptyIcon from '../../../../../asset/svg/requestEmptyIcon.svg';
import commentIcon from '../../../../../asset/svg/Comment.svg';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Checkin from '../../../../../asset/svg/Checkin.svg';
import Checkout from '../../../../../asset/svg/Checkout.svg';
import moment from 'moment';

function AttendanceRequest() {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { AttendanceRequestData, } = useSelector(mapStateToProps);
    const [request, setRequest] = useState([])
    const [page1, setPage1] = useState(0);
    const [pageSize1, setPageSize1] = useState(100);
    const [totalCount1, setTotalCount1] = useState(10);
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedRemarkUserDetails, setSelectedRemarkUserDetails] = useState({});
    const [remarkmodal, setRemarkmodal] = useState(false)
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener("resize", handleResize); handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const columns = [
        {
            field: "requestedByName",
            headerName: "All Employee",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: '6px', fontWeight: 600, fontSize: '12px' }}>
                <div >{params?.formattedValue && params?.formattedValue.length > 8 ? params?.formattedValue.substring(0, 8) + "..." : params?.formattedValue}</div>
                <div style={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '12px' }}>{params?.row?.requestedBy}</div>
            </div>
        },
        {
            field: "checkInTime",
            headerName: "In",
            type: "number",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '6px', fontWeight: 600, fontSize: '12px' }}>
                <div >{params?.formattedValue?.split(',')[0]}</div>
                <div style={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '12px' }}>{params?.formattedValue?.split(',')[1]}</div>
            </div>
        },
        {
            field: "checkOutTime",
            headerName: "Out",
            type: "number",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '6px', fontWeight: 600, fontSize: '12px' }}>
                <div >{params?.formattedValue?.split(',')[0]}</div>
                <div style={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '12px' }}>{params?.formattedValue?.split(',')[1]}</div>
            </div>
        },
        {
            field: "Remarks",
            headerName: "remarks",
            type: "number",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <img src={commentIcon} alt="" style={{ borderRadius: '1px' }} />
        },
    ];

    const getAttendanceRequestData = () => {
        dispatch({
            type: GET_ATTENDANCE_REQUEST_DATA,
            payload: { page1, pageSize1, EmployeeCode },
        });
    };

    useEffect(() => {
        getAttendanceRequestData();
    }, [])

    useEffect(() => {
        if (Object.keys(AttendanceRequestData).length > 0) {
            const requestData = AttendanceRequestData?.entities;
            const modifiedRequestData = requestData && requestData?.length > 0 && requestData.map((item) => ({
                ...item,
                checkInTime: item?.checkInTime ? moment(item?.checkInTime).format("MMM DD, HH:mm A") : '',
                checkOutTime: item?.checkOutTime ? moment(item?.checkOutTime).format("MMM DD, HH:mm A") : '',
                requestedTime: item?.requestedTime ? moment(item?.requestedTime).format("MMM DD, HH:mm A") : '',
                oldCheckInTime: item?.oldCheckInTime ? moment(item?.oldCheckInTime).format("MMM DD, HH:mm A") : '',
                oldCheckOutTime: item?.oldCheckOutTime ? moment(item?.oldCheckOutTime).format("MMM DD, HH:mm A") : '',
            }))
            setRequest(modifiedRequestData);
            setTotalCount1(AttendanceRequestData.total);
        }
    }, [AttendanceRequestData])


    const handleRowClick = (params) => {
        // const prevState = [...selectionModel];
        // const isExist = prevState.findIndex(id => id?.id === params.row.id);
        // if (isExist < 0) {
        //     setRemarkmodal(false);
        // } else {
        setSelectedRemarkUserDetails(params?.row);
        setRemarkmodal(true);
        // }
    };

    const handleRejectRequest = () => {
        const requestDataEntities = selectionModel && selectionModel.length > 0 && selectionModel.map(data => {
            const { approverName, requestedTime, status, timesheetId, checkInTime, checkOutTime, oldCheckInTime, oldCheckOutTime, reason, requestedBy, requestedByName, ...rest } = data
            return rest
        }).map((data) => {
            return {
                approvalId: data?.id,
                approverCode: data?.approver,
                comment: data?.comment ? data?.comment : '',
            }
        })
        dispatch({
            type: POST_ATTENDANCE_REJECT_DATA,
            payload: { requestDataEntities },
            enqueueSnackbar: enqueueSnackbar,
            setRemarkmodal: setRemarkmodal,
            setSelectionModel: setSelectionModel,
            getAttendanceRequestData: getAttendanceRequestData,

        });
    }

    const handleReject = () => {
        const tempSelecteionModel = [...selectionModel];
        const filterData = tempSelecteionModel.find(item => item.id === selectedRemarkUserDetails?.id);
        if (filterData) {
            filterData.comment = selectedRemarkUserDetails?.comment ? selectedRemarkUserDetails.comment : '';
            setSelectionModel(tempSelecteionModel);
            handleRejectRequest();
        }

    }
    const handleCellClick = (params) => {
        // const isCheckboxColumn = params?.field === '__check__';
        // if (isCheckboxColumn) {
        setSelectionModel(prev => {
            const prevState = [...prev];
            const isExist = prevState.findIndex(id => id?.id === params?.row?.id);
            if (isExist < 0) {
                prevState.push(params?.row);
            } else {
                prevState.splice(isExist, 1)
            }
            return prevState;
        })
        setSelectedRemarkUserDetails(params?.row)
        // }
    }

    const handleOnColumnHeaderClick = () => {
        if (selectionModel?.length > 0) {
            setSelectionModel([])
        } else {
            const SelectedAll = [...selectionModel, ...AttendanceRequestData?.entities]
            setSelectionModel(SelectedAll)
        }
    }

    const handleChange = (value) => {
        // setSelectionModel((prevData) => prevData.map((item) => item.id === id ? { ...item, comment: value } : item))
        setSelectedRemarkUserDetails(prev => ({ ...prev, comment: value }))
    }

    const handleApprove = () => {
        const tempSelecteionModel = [...selectionModel];
        const filterData = tempSelecteionModel.find(item => item.id === selectedRemarkUserDetails?.id);
        filterData.comment = selectedRemarkUserDetails.comment ? selectedRemarkUserDetails.comment : '';
        setSelectionModel(tempSelecteionModel);
        handleApproveRequest()
    }

    const handleApproveRequest = () => {
        const requestDataEntities = selectionModel && selectionModel.length > 0 && selectionModel.map(data => {
            const { approverName, requestedTime, status, timesheetId, checkInTime, checkOutTime, oldCheckInTime, oldCheckOutTime, reason, requestedBy, requestedByName, ...rest } = data
            return rest
        }).map((data) => {
            return {
                approvalId: data?.id,
                approverCode: data?.approver,
                comment: data?.comment ? data?.comment : '',
            }
        })
        dispatch({
            type: POST_ATTENDANCE_APPROVE_DATA,
            payload: { requestDataEntities },
            enqueueSnackbar: enqueueSnackbar,
            setRemarkmodal: setRemarkmodal,
            setSelectionModel: setSelectionModel,
            getAttendanceRequestData, getAttendanceRequestData,
        });
    }

    const handleCloseModal = () => {
        setRemarkmodal(false);
        setSelectionModel([])
    }

    document.documentElement.style.setProperty('--screen-width', (windowSize.width) + 'px');

    return (
        <div className="attendanceTable-container">
            <div className="attendanceTable-container_dataGrid">
                {request && request.length > 0 ? <DataGrid style={{ width: windowSize.width, padding: '0 0.5rem' }}
                    rows={request}
                    columns={columns}
                    checkboxSelection
                    disableRowSelectionOnClick
                    onRowClick={handleRowClick}
                    onCellClick={handleCellClick}
                    selectionModel={selectionModel}
                    onColumnHeaderClick={handleOnColumnHeaderClick}
                /> :
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '139px', height: '139px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                            <img style={{ heigth: '54px', width: '40px' }} src={requestEmptyIcon} alt="" />
                        </div>
                        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                            <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No request yet</Typography>
                        </div>
                    </div>}
            </div>
            <div>
                <Modal
                    open={remarkmodal}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >

                    <Box sx={{ backgroundColor: ' #0B245F;', borderRadius: '20px', padding: '1rem', display: 'flex', flexDirection: 'column', gap: '10px', width: "85%" }}>
                        <div className='attendanceTable-container_closeButton' >
                            <IconButton aria-label="close" sx={{ color: '#FFFFFF' }} onClick={handleCloseModal}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <div className="attendanceTable-container_requestedOn-container">
                            <div>
                                <Typography sx={{ color: '#FFF', fontWeight: 700, fontSize: '14px' }}>{selectedRemarkUserDetails?.requestedByName && selectedRemarkUserDetails?.requestedByName.length > 20 ? selectedRemarkUserDetails?.requestedByName.substring(0, 20) + '...' : selectedRemarkUserDetails?.requestedByName}</Typography>
                                <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>{selectedRemarkUserDetails?.requestedBy}</Typography>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>Requested On</Typography>
                                <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>{selectedRemarkUserDetails?.requestedTime}</Typography>
                            </div>
                        </div>
                        <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                            <div className="attendanceTable-Container_checkIn">
                                <img className='attendanceTable-Container_header_image' src={Checkin} alt="" />&nbsp;&nbsp;
                                <span style={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Check In</span></div>
                            <div className="attendanceTable-container_checkIn-content">
                                <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>Old : <span className="attendanceTable-container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.oldCheckInTime}</span></Typography>
                                <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>New : <span className="attendanceTable-container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.checkInTime}</span></Typography>
                            </div>
                        </Box>
                        <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                            <div className="attendanceTable-Container_checkIn">
                                <img className='attendanceTable-Container_header_image' src={Checkout} alt="" />&nbsp;&nbsp;
                                <span style={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Check Out</span></div>
                            <div className="attendanceTable-container_checkIn-content">
                                <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>Old : <span className="attendanceTable-container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.oldCheckOutTime}</span></Typography>
                                <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>New : <span className="attendanceTable-container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.checkOutTime}</span></Typography>
                            </div>
                        </Box>
                        <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                            <div className="attendanceTable-container_checkIn-heading">
                                <Typography sx={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Reason For Update : </Typography>
                                <Typography sx={{ color: '#FFF', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize', padding: '10px 0px 0px 0px' }}>{selectedRemarkUserDetails?.reason}</Typography>
                            </div>
                        </Box>
                        <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                            <div className="attendanceTable-container_checkIn-heading">
                                <Typography sx={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Manager Comments : </Typography>
                                <div>
                                    <FormControl sx={{ width: 250, height: 50, borderRadius: '12px' }}>
                                        <TextField fullWidth multiline InputProps={{ rows: 3, }} className={'attendanceTable-container_checkIn-heading_text-area'}
                                            value={selectedRemarkUserDetails?.comment} name='comment' placeholder='Type Here' onChange={(event) => handleChange(event.target.value, selectedRemarkUserDetails?.id)}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </Box>
                        <div className='attendanceTable-container_approvebutton-container'>
                            <button className='attendanceTable-container_approvebutton-container_rejectbutton' onClick={handleReject}>Reject</button>
                            <button className='attendanceTable-container_approvebutton-container_approvebutton' onClick={handleApprove}>Approve</button>
                        </div>
                    </Box>
                </Modal>
            </div>

            {!remarkmodal && (selectionModel && selectionModel.length > 0) && <div className='attendanceTable-container_approvebutton-container'>
                <button className='attendanceTable-container_approvebutton-container_rejectbutton' onClick={handleReject}>Reject</button>
                <button className='attendanceTable-container_approvebutton-container_approvebutton' onClick={handleApprove}>Approve</button>
            </div>}
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        AttendanceRequestData: state.attendanceConfig.AttendanceRequestData,
    }
}

export default AttendanceRequest;
